export default function MaxDepthList(t){
  if (t.length === 0){
    return 0;
  }
  var max = 0;
  for (var i = 0; i < t.length; i++){
    if (t[i].c){
      var p = MaxDepthList(t[i].c);
    }      
    if (p > max){
      max = p; 
    }
  }
  return max + 1;
}
